import React from "react";
import { createRoot } from "react-dom/client";
import { createStore, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";

import makeMainReducer from "./reducers";
import { ajaxRequestMiddleware, sagaMiddleware } from "./middlewares";
import rootSaga from "./sagas";

export default (rootReactComponent, focusViewReducer, extraMiddlewares = []) => {
  return class RegulationApp {
    constructor(htmlNode, propsAndState) {
      const composeEnhancers =
        typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
          window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose;

      const initialState = propsAndState;
      const reducer = makeMainReducer(focusViewReducer);

      const mids = applyMiddleware(ajaxRequestMiddleware,
                                   sagaMiddleware,
                                   ...extraMiddlewares);
      const finalEnhancer = composeEnhancers(mids);

      const store = createStore(
        reducer,
        initialState,
        finalEnhancer);

      this.store = store;

      sagaMiddleware.run(rootSaga);

      const wrapApp = (AppComponent, reduxStore) =>
      <Provider store={reduxStore}>
        <AppComponent {...propsAndState.props} />
      </Provider>;

      createRoot(htmlNode).render(wrapApp(rootReactComponent, store));
    }
  };
};
